import { OnboardingTrialStepsType, ClientFlags } from '@sdk/authentication/types';

const isStepCompleted = (clientFlags: ClientFlags, step: OnboardingTrialStepsType): boolean => {
  return Boolean(clientFlags[step].completed);
};

export default isStepCompleted;
